import { Badge } from '@flote/ui';
import type { DriverStatus } from '@flote/types/delivery';

interface DriverStatusBadgeConfig {
  label: string;
  className: string;
}

const DRIVER_STATUS_CONFIG: Record<DriverStatus, DriverStatusBadgeConfig> = {
  off_duty: {
    label: 'Off Duty',
    className: 'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-100',
  },
  idle: {
    label: 'Idle',
    className: 'bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100',
  },
  active: {
    label: 'Active',
    className: 'bg-green-100 text-green-800 border-green-200 hover:bg-green-100',
  },
};

interface DriverStatusBadgeProps {
  status: DriverStatus;
  className?: string;
}

export function DriverStatusBadge({ status, className }: DriverStatusBadgeProps) {
  const config = DRIVER_STATUS_CONFIG[status] ?? {
    label: status,
    className: 'bg-gray-100 text-gray-800 border-gray-200',
  };

  return (
    <Badge className={`${config.className} ${className ?? ''}`}>
      {config.label}
    </Badge>
  );
}
